import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import moment from "moment";
import EntityHeader from "./common/EntityHeader";
import FieldDisplay from "./common/FieldDisplay";
import AddressModal from "./common/AddressModal";
import {
  getFieldDate,
  getFieldText,
  getFieldName,
  getFieldFormattedValue,
  formatDate,
} from "../scripts/helperScripts";

import "react-datepicker/dist/react-datepicker.css";

function AddressesEntity({
  clientId,
  clientProgram,
  addresses,
  showExpired,
  updateAddresses,
  setAddressBeingCreated,
  businessUnitName,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [addressData, setAddressData] = useState({});
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  useEffect(() => {
    if (safyInfo) {
      const modules = safyInfo.user.modules;
      if (
        modules.includes("My Caseload") === false &&
        modules.includes("Team Caseload") === false &&
        modules.includes("Foster Homes") === false
      ) {
        navigate("/");
      }
    } else navigate("/");
  });

  const hideModal = () => {
    setIsOpen(false);
  };

  const showModal = (address) => {
    const addressObj = {
      ccx_addresstype: getFieldFormattedValue(address.ccx_addresstype),
      ccx_receivestatement:
        getFieldName(address.ccx_receivestatement) === "Yes",
      ccx_line1: address.ccx_line1 && address.ccx_line1,
      ccx_city: address.ccx_city && address.ccx_city,
      ccx_state_lu: getFieldText(address.ccx_state_lu),
      ccx_state: address.ccx_state,
      ccx_postalcode: address.ccx_postalcode && address.ccx_postalcode,
      ccx_county_lu: getFieldText(address.ccx_county_lu),
      ccx_effectivedate: moment(getFieldDate(address.ccx_effectivedate)).format(
        moment.HTML5_FMT.DATE
      ),
      ccx_expirationdate: address.ccx_expirationdate
        ? moment(getFieldDate(address.ccx_expirationdate)).format(
            moment.HTML5_FMT.DATE
          )
        : undefined,
      ccx_contactaddressid: address.ccx_contactaddressid,
      stateName: getFieldName(address.ccx_state_lu),
      countyName: getFieldName(address.ccx_county_lu),
    };
    setAddressData(addressObj);
    setIsOpen(true);
  };

  const addNew = () => {
    setAddressData();
    setIsOpen(true);
  };

  return (
    <>
      <AddressModal
        isOpen={isOpen}
        hideModal={hideModal}
        clientId={clientId}
        clientProgram={clientProgram}
        initialData={addressData}
        updateAddresses={updateAddresses}
        setAddressBeingCreated={setAddressBeingCreated}
        businessUnitName={businessUnitName}
      ></AddressModal>
      <EntityHeader
        title={"Addresses"}
        add={
          addresses.filter(
            (address) =>
              getFieldName(address.ccx_addresstype) === "Home" &&
              address.ccx_expirationdate === undefined
          ).length === 0
            ? addNew
            : null
        }
        {...rest}
        body={addresses.map((address) => (
          <div
            className={
              address.ccx_expirationdate !== undefined && !showExpired
                ? "d-none p-2"
                : "d-block p-2"
            }
            key={address.ccx_contactaddressid}
          >
            <Card bg="dark" className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">
                    {getFieldName(address.ccx_addresstype)}
                  </div>
                  <div className="col-2">
                    <i
                      className="fas fa-pen float-end p-2"
                      onClick={() => showModal(address)}
                    ></i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  address.ccx_expirationdate === undefined
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                <div className="mb-2">
                  <strong>
                    {address.ccx_line1 ? address.ccx_line1 + ", " : ""}
                    {address.ccx_city ? address.ccx_city + ", " : ""}
                    {address.ccx_state ? address.ccx_state + " " : ""}
                    {address.ccx_postalcode ? address.ccx_postalcode : ""}
                  </strong>
                </div>
                <div className="row">
                  <div className="col-5">
                    <FieldDisplay
                      label="Eff Date: "
                      value={getFieldDate(address.ccx_effectivedate)}
                    />
                  </div>
                  <div className="col-2"></div>
                  <div className="col-5">
                    {address.ccx_expirationdate && (
                      <FieldDisplay
                        label="Exp Date: "
                        value={getFieldDate(address.ccx_expirationdate)}
                      />
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default AddressesEntity;
